/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import AdminBreadcrumb from '../../../../client/js/components/breadcrumb/AdminBreadcrumb'
import { FormattedMessage } from 'react-intl'
import { ReactNode } from 'react'
import { getCustomerName } from '../../lib/customer.mjs'
import { getCustomerLink, getCustomerListLink } from '../../lib/links/customerLinks'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import { Divider } from '@mantine/core'
import CustomerTabs from './CustomerTabs'
import BreadcrumbCard from '../../../../client/js/components/breadcrumb/BreadcrumbCard'

export type CustomerBreadcrumbProps = {
  customer?: Partial<Customer>,
  title: ReactNode
}

function CustomerBreadcrumb (props: CustomerBreadcrumbProps) {
  const { customer, title } = props
  return (
    <BreadcrumbCard>
      <AdminBreadcrumb>
        <AnchorLink to={getCustomerListLink()}>
          <FormattedMessage
            id="contacts"
            defaultMessage="Contacts"
          />
        </AnchorLink>

        {customer?.id != null
          ? <AnchorLink to={getCustomerLink(customer.id)}>
            {getCustomerName(customer)}
          </AnchorLink>
          : null}

        <span>{title}</span>
      </AdminBreadcrumb>

      {customer?.id > 0
        ? <>
          <Divider my="xs" />
          <CustomerTabs customerId={customer?.id} />
        </>
        : null}
    </BreadcrumbCard>
  )
}

export default CustomerBreadcrumb
